import { useTranslation } from "react-i18next";
import type { ChatMessage } from "@crashx/shared";
import { ChatModeration } from "./ChatModeration.js";

export function ChatMessageRow({ message, canModerate }: { message: ChatMessage; canModerate: boolean }) {
  const { t } = useTranslation();
  const variant = Number(message.avatar.replace("geo-", "")) || 1;
  return (
    <li className="cx-chat-message">
      <div className="flex items-center gap-2">
        <span className="cx-avatar" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path
              d={
                variant % 3 === 0
                  ? "M12 3 22 21H2Z"
                  : variant % 3 === 1
                    ? "M12 2 22 12 12 22 2 12Z"
                    : "M4 4h16v16H4Z"
              }
            />
          </svg>
        </span>
        <strong className="min-w-0 break-all">{message.nick}</strong>
        <span className="text-xs text-muted">{t(`chat.roles.${message.role}`)}</span>
      </div>
      <p className="m-0 whitespace-pre-wrap break-words">{message.text}</p>
      {canModerate ? <ChatModeration message={message} /> : null}
    </li>
  );
}
